import * as React from 'react';
import { FlatList, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { useSelector, useDispatch } from 'react-redux';
import { Text, Divider } from 'react-native-paper';
import { CustomButton } from '../components/CustomButton';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    //flex: 1,
  },
  item: {
    marginVertical: 4,
  },
  emptyView: {
    padding: 20,
  },
  mainView: {
    backgroundColor: "#ffffff",
    margin: 5,
    borderWidth: 1,
    borderTopWidth: 5,
    borderColor: "#e4e9f2",
  },
  link: {
    color: "#0000EE",
    textDecorationLine: "underline",
    paddingTop: 10,
    //padding: 20,
    //paddingLeft: 25,
  },
  descriptionView: {
    padding: 10,
    paddingLeft: 25,
    paddingBottom: 10,
  },
  titleWrapper: {
    padding: 20,
    paddingLeft: 25,
  },
  descriptionSplit: {
    flex: 1,
    flexDirection: "row",
  },
  descriptionRight: {
    width: 10,
    padding: 100,
  },
  certificationImage: {
    width: 85,
    marginRight: 10,
    marginBottom: 10,
  },
  certifications: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 5,
  },
  certificationsIntro: {
    marginTop: 20,
  },
  listProductsButton: {
    paddingTop: 10,
    //backgroundColor: "#ffffff"
  },
  searchWrapper: {
    padding: 10,
    minHeight: 75,
    //maxHeight: 300,
  },
  buttonView: {
    padding: 10,
    paddingLeft: 25,
    paddingVertical: 20,
  },
  certificationsView: {
    paddingTop: 10,
  },
  headerWrapper: {
    padding: 10,
    paddingVertical: 20,
  },
  subtitle: {
    //color: "#0000EE",
    paddingTop: 10,
    fontWeight: "bold",
  },
  normal: {
    lineHeight: 25,
  },
});

function filterToItem(filterName, minimum) {
  return {
    key: filterName,
    title: AppConstants.DATA_FILTERS_BUILTIN_REVERSE_MAP[filterName],
    subtitle: AppConstants.DEFAULT_FILTER_SUBTITLES[filterName],
    certifications: AppConstants.FILTER_RECOMMENDED_VALUES_UNIQUE[filterName],
    description: AppConstants.DEFAULT_FILTER_DESCRIPTIONS[filterName],
    showCertifications: true,
    minimum: minimum,
  };
}

function getFilterTitle(filter) {
  return filter;
}

function getButtonText(selectedItem, item) {
  if (selectedItem == item.key) {
    return "Currently selected";
  } else {
    return "Apply " + item.title.replace(AppConstants.ASPCA_RECOMMENDED_SUFFIX, "");
  }
}

function doShowCertification(certification) {
  if (certification == "animal_welfare_approved" ||
      certification.startsWith("certified_humane") ||
      certification == "regenerative_organic_certified" ||
      (certification.startsWith("animal_welfare_certified") && !certification.startsWith("animal_welfare_certified_fish"))) {
    return true;
  }
  return false;
}

function getCertificationImage(filter) {
  return AppUtilities.getCertificationImage(filter, styles.certificationImage);
}

export function Filter({ navigation, header, footer, navigateCallback }) {
  const dispatch = useDispatch();
  const lastMainView = useSelector((state) => state.lastMainView);
  const dataFilter = useSelector((state) => state.dataFilter);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const onApply = async (filterName) => {
    AppState.changeCertificationGroup(dataFilter, filterName, dispatch);
    if (navigateCallback) {
      AppUtilities.info("Calling navigateCallback");
      navigateCallback();
    } else {
      AppUtilities.info("Navigating to " + lastMainView);
      navigation.navigate(lastMainView);
    }
  };

  React.useEffect(() => {
    if (dataFilter) {
      if (dataFilter[AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedItem(AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]);
      } else if (dataFilter[AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedItem(AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]);
      } else if (dataFilter[AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedItem(AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]);
      }
    }
  }, [dataFilter]);

  const renderItem = ({item}) => {
    const certification_images = [];
    if (item.showCertifications) {
      Object.keys(item.certifications).filter(doShowCertification).forEach((key) => {
        if (item.certifications[key]) {
          certification_images.push(getCertificationImage(key));
        }
      });
    }

    return (
      <View style={styles.mainView}>
        <View style={styles.titleWrapper}>
          <Text variant="bodyLarge">
            {getFilterTitle(item.title)}
          </Text>
          <Text style={styles.subtitle}>
            {item.subtitle}
          </Text>
        </View>
        <Divider />
        <View style={styles.descriptionView}>
          <View>
            <Text selectable={true}>
              {
                item.description
              }
            </Text>
            {
              item.showCertifications ?
                  <View style={styles.certificationsView}>
                    {
                      certification_images.length > 0 ?
                          <>
                            <Text>{item.minimum ? "Minimum certifications" : "Certifications"}:</Text>
                            <View style={styles.certifications}>
                              {
                                certification_images
                              }
                            </View>
                          </>
                        :
                          null
                    }
                  </View>
                :
                  null
            }
          </View>
        </View>
        <Divider />
        <View style={styles.buttonView}>
          <CustomButton
            disabled={selectedItem == item.key}
            onPress={() => onApply(item.key)}
          >
            { getButtonText(selectedItem, item) }
          </CustomButton>
        </View>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <FlatList
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={styles.contentContainer}
        data={[
          filterToItem(AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY], false),
          filterToItem(AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY], true),
          filterToItem(AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY], true),
        ]}
        renderItem={renderItem}
        keyExtractor={item => item.title}
        ListEmptyComponent={() => {
          if (!dataFilter) return null;
          return (
            <View style={styles.emptyView}>
              <Text variant="bodyMedium">No filters</Text>
            </View>
          );
        }}
        ListHeaderComponent={(
          <View style={styles.headerWrapper}>
            {header}
            <Text selectable={true} style={styles.normal}>Choose from one of our built-in filters below or customize in detail on the {AppUtilities.createInternalLink(navigation, "Search page", AppConstants.SCREENS.SEARCH)}. {AppUtilities.LABEL_GUIDES}</Text>
          </View>
        )}
        ListFooterComponent={footer}
      />
    </View>
  );
}
